import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {API_BASE_URL} from '../../../api/client';
import {depositBucket, guestStayDateIssue} from '../../../utils/dashboardGuestStats';

class DashboardStats extends Component {
    state = {
        loading: true,
        overdue: 0,
        soon: 0,
        missingDeposit: 0,
        totalGuests: 0,
        missingStayDates: 0,
        missingStartDate: 0,
        missingEndDate: 0,
        familyGuestCount: 0,
        otherGuestCount: 0,
        emptyBeds: null,
    };

    componentDidMount() {
        this.loadStats();
    }

    loadStats = async () => {
        const headers = {'Authorization': localStorage.getItem('accessToken')};
        try {
            const chars = await axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/search?parentType=Person`, {headers})
                .then(r => r.data);
            const list = Array.isArray(chars) ? chars : [];
            let overdue = 0;
            let soon = 0;
            let missingDeposit = 0;
            let totalGuests = 0;
            let missingStayDates = 0;
            let missingStartDate = 0;
            let missingEndDate = 0;
            let familyGuestCount = 0;
            let otherGuestCount = 0;

            list.forEach((c) => {
                const isGuest = c.personType === 'familyGuest' || c.personType === 'otherGuest';
                if (!isGuest) return;
                totalGuests += 1;
                if (c.personType === 'familyGuest') familyGuestCount += 1;
                if (c.personType === 'otherGuest') otherGuestCount += 1;

                const bucket = depositBucket(c.depositReturnDate);
                if (bucket === 'overdue') overdue += 1;
                else if (bucket === 'soon') soon += 1;
                else if (bucket === 'missing') missingDeposit += 1;

                const stayIssue = guestStayDateIssue(c);
                if (stayIssue) {
                    missingStayDates += 1;
                    if (stayIssue === 'start' || stayIssue === 'both') missingStartDate += 1;
                    if (stayIssue === 'end' || stayIssue === 'both') missingEndDate += 1;
                }
            });

            let emptyBeds = null;
            try {
                const beds = await axios.get(`${API_BASE_URL}/api/v1/supervisor/bed/concat/empty`, {headers}).then(r => r.data);
                emptyBeds = Array.isArray(beds) ? beds.length : null;
            } catch (e) { /* optional */ }

            this.setState({
                loading: false,
                overdue,
                soon,
                missingDeposit,
                totalGuests,
                missingStayDates,
                missingStartDate,
                missingEndDate,
                familyGuestCount,
                otherGuestCount,
                emptyBeds,
            });
        } catch (e) {
            this.setState({loading: false});
        }
    };

    render() {
        const {
            loading, overdue, soon, missingDeposit, totalGuests,
            missingStayDates, missingStartDate, missingEndDate,
            familyGuestCount, otherGuestCount, emptyBeds,
        } = this.state;

        return (
            <div className="px-3 py-3">
                <div className="page-title-row mb-4">
                    <h4>داشبورد آمار</h4>
                </div>
                {loading ? (
                    <div className="text-muted">در حال بارگذاری...</div>
                ) : (
                    <div className="row g-3">
                        <div className="col-12 col-md-4">
                            <div className="p-3 border rounded" style={{background: '#fff'}}>
                                <div className="text-muted small">عودت ودیعه گذشته‌موعد</div>
                                <div className="fs-3 text-danger fw-bold">{overdue}</div>
                                <Link to="/dashboard/people?depositFilter=overdue" className="small">مشاهده فقط گذشته‌موعد</Link>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="p-3 border rounded" style={{background: '#fff'}}>
                                <div className="text-muted small">عودت ودیعه در ۷ روز آینده</div>
                                <div className="fs-3 text-warning fw-bold">{soon}</div>
                                <Link to="/dashboard/people?depositFilter=soon" className="small">مشاهده لیست ۷ روز آینده</Link>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="p-3 border rounded" style={{background: '#fff'}}>
                                <div className="text-muted small">مهمان بدون تاریخ عودت</div>
                                <div className="fs-3 fw-bold">{missingDeposit}</div>
                                <div className="text-muted small">از {totalGuests} مهمان</div>
                                <Link to="/dashboard/people?depositFilter=missing" className="small">مشاهده بدون تاریخ عودت</Link>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="p-3 border rounded" style={{background: '#fff'}}>
                                <div className="text-muted small">مهمان بدون تاریخ شروع/پایان اقامت</div>
                                <div className="fs-3 fw-bold">{missingStayDates}</div>
                                <div className="text-muted small">
                                    شروع: {missingStartDate} · پایان: {missingEndDate}
                                </div>
                                <div className="text-muted small">
                                    بستگان {familyGuestCount} · متفرقه {otherGuestCount}
                                </div>
                                <Link to="/dashboard/people?guestDateFilter=missingStay" className="small">مشاهده مهمانان ناقص</Link>
                            </div>
                        </div>
                        {emptyBeds !== null ? (
                            <div className="col-12 col-md-4">
                                <div className="p-3 border rounded" style={{background: '#fff'}}>
                                    <div className="text-muted small">تخت خالی</div>
                                    <div className="fs-3 fw-bold">{emptyBeds}</div>
                                    <Link to="/dashboard/booking/room_log?empty=1" className="small">گزارش تخت خالی</Link>
                                </div>
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        );
    }
}

export default DashboardStats;
